export const terminalMap = {
    1: { label: "Front Door", icon: "ri-door-open-line", color: "#198754" },
    2: { label: "Mezzanine", icon: "ri-building-line", color: "#0d6efd" },
    4: { label: "Rahul's Office", icon: "ri-user-star-line", color: "#b45309" },
    5: { label: "Shipping", icon: "ri-truck-line", color: "#534AB7" },
};

export const getPunchLocation = (terminalId, computer) => {

    // 1. Biometric punch — terminal_id is set
    if (terminalId && terminalMap[terminalId]) {
        return terminalMap[terminalId];
    }

    // 2. Dashboard punch — terminal_id is null, use computer name
    if (computer && computer.trim() !== "") {
        const pc = computer.trim().toUpperCase();
        const serverMachines = ["SSWDB", "SSWMAIN", "SSWSERVER"];

        if (serverMachines.includes(pc)) {
            return {
                label: "On-Site (Dashboard)",
                icon: "ri-computer-line",
                color: "#6c757d",
            };
        }

        return {
            label: `Dashboard (${computer.trim()})`,
            icon: "ri-remote-control-line",
            color: "#0d6efd",
        };
    }

    // 3. Unknown
    return {
        label: "Unknown",
        icon: "ri-question-line",
        color: "#aaa",
    };
};